export default __webpack_public_path__ + "static/media/about.31f92272.png";